export default "__VITE_ASSET__kCTp9xAR__"